const ACTIONS = {
    GET_MY_RECOMMEND_SUCCESS: 'GET_MY_RECOMMEND_SUCCESS',
    GET_MY_RECOMMEND_ERROR: 'GET_MY_RECOMMEND_ERROR',
};

const data = [
    {
        item: {
            data: {
                id: 1,
                name: '選手名',
                season: 2024,
                value: "数値"
            },
            name: "メジャー名",
            desc: "説明"
        }
    },
]


export default (state = {
    data
}, action) => {
    switch (action.type) {
        case ACTIONS.GET_MY_RECOMMEND_SUCCESS:
            return {
                ...state,
                status: action.type,
                response: action.data,
            };
        case ACTIONS.GET_MY_RECOMMEND_ERROR:
            return {
                ...state,
                status: action.type,
                response: action.err,
            }
        default:
            return state;
    }
};